import './main.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {Helmet} from "react-helmet";
import Header from './components/header/header';
// import Footer from './components/footer/footer';
 
import Financial from './financial/financial';
import FinancialUsage from './financial/subsections/financial-usage';
import FinancialPlanning from './financial/subsections/financial-planning';
import FinancialIntegration from './financial/subsections/financial-integration';
import FinancialMetrics from './financial/subsections/financial-metrics';
import FinancialFuture from './financial/subsections/financial-future';

import Retail from './retail/retail';
import RetailUsage from './retail/subsections/retail-usage';
import RetailPlanning from './retail/subsections/retail-planning';
import RetailIntegration from './retail/subsections/retail-integration';
import RetailMetrics from './retail/subsections/retail-metrics';
import RetailFuture from './retail/subsections/retail-future';

import CPG from './cpg/cpg';
import CPGUsage from './cpg/subsections/cpg-usage';
import CPGPlanning from './cpg/subsections/cpg-planning';
import CPGIntegration from './cpg/subsections/cpg-integration';
import CPGMetrics from './cpg/subsections/cpg-metrics';
import CPGFuture from './cpg/subsections/cpg-future';

import Insurance from './insurance/insurance';
import InsuranceUsage from './insurance/subsections/insurance-usage';
import InsurancePlanning from './insurance/subsections/insurance-planning';
import InsuranceIntegration from './insurance/subsections/insurance-integration';
import InsuranceMetrics from './insurance/subsections/insurance-metrics';
import InsuranceFuture from './insurance/subsections/insurance-future';

import Health from './health/health';
import HealthUsage from './health/subsections/health-usage';
import HealthPlanning from './health/subsections/health-planning';
import HealthIntegration from './health/subsections/health-integration';
import HealthMetrics from './health/subsections/health-metrics';
import HealthFuture from './health/subsections/health-future';

import TakeAways from './takeaways/takeaways';

function App() {

  return (
    <div className="App">

    <Helmet>
        <meta charset="UTF-8"></meta>
        <title>Insights on Direct Mail Usage by Industry | USPS Delivers</title>
        <meta name="description" content="USPS commissioned a proprietary study to find out how companies across different industries are making use of direct mail. Explore now." />
    </Helmet>
      
      <BrowserRouter basename="/direct-mail-insights">
        <Header />
        <Routes>

          <Route path="/key-takeaways" element={<TakeAways />} />
          
          <Route path="/financial" element={<Financial />} >
            <Route index element={<FinancialUsage />} />
            <Route path="/financial/planning" element={<FinancialPlanning />} />
            <Route path="/financial/integration" element={<FinancialIntegration />} />
            <Route path="/financial/metrics" element={<FinancialMetrics />} />
            <Route path="/financial/future" element={<FinancialFuture />} />
          </Route>

          <Route path="/retail" element={<Retail />}>
            <Route index element={<RetailUsage />} />
            <Route path="/retail/planning" element={<RetailPlanning />} />
            <Route path="/retail/integration" element={<RetailIntegration />} />
            <Route path="/retail/metrics" element={<RetailMetrics />} />
            <Route path="/retail/future" element={<RetailFuture />} />
          </Route>

          <Route path="/cpg" element={<CPG />}>
            <Route index element={<CPGUsage />} />
            <Route path="/cpg/planning" element={<CPGPlanning />} />
            <Route path="/cpg/integration" element={<CPGIntegration />} />
            <Route path="/cpg/metrics" element={<CPGMetrics />} />
            <Route path="/cpg/future" element={<CPGFuture />} />
          </Route>

          <Route path="/insurance" element={<Insurance />}>
            <Route index element={<InsuranceUsage />} />
            <Route path="/insurance/planning" element={<InsurancePlanning />} />
            <Route path="/insurance/integration" element={<InsuranceIntegration />} />
            <Route path="/insurance/metrics" element={<InsuranceMetrics />} />
            <Route path="/insurance/future" element={<InsuranceFuture />} />
          </Route>

          <Route path="/health" element={<Health />}>
            <Route index element={<HealthUsage />} />
            <Route path="/health/planning" element={<HealthPlanning />} />
            <Route path="/health/integration" element={<HealthIntegration />} />
            <Route path="/health/metrics" element={<HealthMetrics />} />
            <Route path="/health/future" element={<HealthFuture />} />
          </Route>

          <Route path="/" element={<Financial />} />
        </Routes>

      </BrowserRouter>


      
    </div>
  );
}


export default App;
